
import { Component, Prop, Vue } from "vue-property-decorator";
import DashboardCardScaffold from "@/components/dashboard/cards/CardScaffoldManagers.vue";
import CardItemScaffold from "@/components/dashboard/cards/CardItemScaffold.vue";
import ManagerIcon from "@/components/icons/ManagerIcon.vue";
import SimplePersonIcon from "@/components/icons/SimplePersonIcon.vue";
import ItemChipsWithMore from "@/components/common/ItemChipsWithMore.vue";
import RouteNames from "@/entities/RouteNames";
import ManagerInvitationModalWithButton from "@/components/managers/ManagerInvitationModalWIthButton.vue";
import ItemChipsData from "@/entities/ItemChipsData";
import RouteParams from "@/entities/RouteParams";
import ManagersTable from "@/components/dashboard/cards/ManagersTable.vue";
import { Company, Manager, User } from "@/generated/graphql";

@Component({
  components: {
    DashboardCardScaffold,
    ManagerInvitationModalWithButton,
    CardItemScaffold,
    ManagerIcon,
    SimplePersonIcon,
    ItemChipsWithMore,
    ManagersTable,
  }
})
export default class DashboardManagers extends Vue {
  @Prop({ type: String, required: true }) readonly companyId!: string;
  @Prop({ type: String, required: true }) readonly currentUserId!: string;
  @Prop({ type: String, required: true }) readonly companyBusinessName!: string;
  @Prop({ type: Array, default: () => [] }) readonly managers!: any[];
  @Prop({ type: Number, default: undefined }) readonly managersTotal?: number;
  @Prop({ type: Number, default: undefined }) readonly requestsTotal?: number;
  @Prop({ type: Number, default: 0 }) readonly activeManagersCount!: number;
  @Prop({ type: Number, default: 0 }) readonly accessAllowedManagersCount!: number;
  @Prop({ type: Boolean, default: false }) readonly subscriptionRequired!: boolean;
  @Prop({ type: Array, default: () => [] }) readonly managersTable!: Manager[];
  @Prop({ type: Boolean, default: false }) readonly isManager!: boolean;
  @Prop({ type: Boolean, default: false }) readonly isAdmin!: boolean;
  
  @Prop({ type: Object, required: true }) readonly company!: Company;
  @Prop({ type: Object, required: true }) readonly currentUser!: User;

  routes = RouteNames;

  get managersInfo(): ItemChipsData[] | string {
    if (!this.managers.length) {
      return [];
    }
    return this.managers.map((m) => {
      return {
        id: m.id,
        name: `${m.user.given_name} ${m.user.family_name}`,
        avatar: m.user.avatar,
        extra: m.manager_contractors.aggregate.count == 0 ? 0 : m.manager_contractors.aggregate.count,
      }
    })
  }

  get requestsLink(): RouteParams<string> {
    return { name: RouteNames.CONTRACTORS_REQUESTS };
  }

  get requestItemTitle(): string {
    if (!this.requestsTotal || this.requestsTotal === 1) {
      return "Contractor Request";
    }

    return "Contractor Requests";
  }

  get managersTotalMinusViewer(): number {
    var total = this.managersTotal;
    var totalNum: number = 0;
    if (this.isManager) {
      if (total && total > 0) {
        totalNum = total - 1;
      } else if (total && total === 0) {
        totalNum = 0;
      }
    } else {
      if(total) {
        totalNum = total;
      } else {
        totalNum = 0;
      }
    }
    return totalNum;
  }

  refreshPage(): void {
    this.$emit('refresh')
  }
}
